export const PACKAGE_HEROES = {
  europe: {
    title: "Europe Tour Packages",
    destination: "Europe",
    videoLabel: "Glimpse of Europe",
    images: [
      "https://images.unsplash.com/photo-1543349689-9a4d426bee8e?w=800&q=80",
      "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800&q=80",
      "https://images.unsplash.com/photo-1552832230-c0197dd311b5?w=800&q=80",
      "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=800&q=80",
      "https://images.unsplash.com/photo-1491557345352-5929e343eb89?w=800&q=80",
    ],
  },
  goa: {
    title: "Goa Tour Packages",
    destination: "Goa",
    videoLabel: "Glimpse of Goa",
    images: [
      "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=800&q=80",
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80",
      "https://images.unsplash.com/photo-1524613032530-449a5d94c285?w=800&q=80",
      "https://images.unsplash.com/photo-1560179406-1c6c60e0dc76?w=800&q=80",
      "https://images.unsplash.com/photo-1484821582734-6c6c9f99a672?w=800&q=80",
    ],
  },
  kerala: {
    title: "Kerala Tour Packages",
    destination: "Kerala",
    videoLabel: "Glimpse of Kerala",
    images: [
      "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=800&q=80",
      "https://images.unsplash.com/photo-1593693397690-362cb9666fc2?w=800&q=80",
      "https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=800&q=80",
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=800&q=80",
      "https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=800&q=80",
    ],
  },
  default: {
    title: "Holiday Tour Packages",
    destination: "Holiday",
    videoLabel: "Glimpse of Destination",
    images: [
      "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&q=80",
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=800&q=80",
      "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800&q=80",
      "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=800&q=80",
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80",
    ],
  },
};

export const NEARBY_PACKAGE_LINKS = [
  "Indonesia",
  "Malaysia",
  "Singapore",
  "Kuala Lumpur",
  "Vietnam",
  "Thailand",
];

export const DOMESTIC_PACKAGE_LINKS = [
  "Goa",
  "Kerala",
  "Andaman",
  "Himachal",
  "Kashmir",
  "Rajasthan",
];

export function slugifyPlace(place = "") {
  return String(place)
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function titleFromSlug(slug = "") {
  return String(slug || "holiday")
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function formatPackagePrice(price, currency = "INR") {
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(price);
  } catch {
    // Unknown/invalid currency code — fall back to INR.
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(price);
  }
}

const API_BASE =
  (
    typeof process !== "undefined" && process.env?.REACT_APP_API_URL
      ? process.env.REACT_APP_API_URL
      : "http://localhost:5000"
  ).replace(/\/$/, "") + "/api";


async function apiFetch(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  if (!res.ok) throw new Error(`API ${path} → ${res.status}`);
  return res.json();
}

export async function fetchPublishedPackages() {
  return apiFetch("/packages");
}

export function getPackageHero(placeSlug) {
  const fallbackName = titleFromSlug(placeSlug);
  const base = PACKAGE_HEROES[placeSlug] || PACKAGE_HEROES.default;
  return {
    ...base,
    title: PACKAGE_HEROES[placeSlug]?.title || `${fallbackName} Tour Packages`,
    destination: PACKAGE_HEROES[placeSlug]?.destination || fallbackName,
    videoLabel: PACKAGE_HEROES[placeSlug]?.videoLabel || `Glimpse of ${fallbackName}`,
  };
}

export function getPackagesForPlace(packages = [], placeSlug = "") {
  const normalizedSlug = slugifyPlace(placeSlug);

  if (!normalizedSlug) return [];

  return packages.filter((pkg) => {
    const destinationSlug = slugifyPlace(
      pkg.destination || pkg.place || pkg.location || ""
    );

    return destinationSlug === normalizedSlug;
  });
}

export function getAboutContent(placeSlug) {
  const place = titleFromSlug(placeSlug);
  const pure = place.split(" ")[0] || place;
  return {
    title: `About ${place}`,
    paragraphs: [
      `${place} has been a dream destination for travellers and remains one of the most loved holiday choices for families, couples and groups. Scenic stays, local markets, cultural corners and memorable day trips shape the character of this destination.`,
      `People choose ${place} because it offers variety without effort. Sightseeing, relaxed stays, guided experiences and good food are often close together, so getting around does not take much effort.`,
      `Planning a visit soon? This guide explains what to expect when exploring ${place} holiday packages before booking.`,
    ],
    subTitle: `The Beauty Of ${place}: What Makes This Destination Special`,
    subText: `${place} feels different to different people, and that is what makes it stand out. Whether you want a slow holiday, a packed itinerary or a premium escape, the right package helps you experience the destination with less planning stress.`,
  };
}

export function getExpandedAboutContent(placeSlug) {
  const place = titleFromSlug(placeSlug);
  const pure = place.split(" ")[0] || place;
  return {
    intro: [
      `${place} feels different to different people, and that is what makes it stand out. Local culture, food, shopping streets, temples, beaches, markets and scenic viewpoints give travellers many ways to plan the same holiday.`,
      `Today, ${place} is one of the popular holiday choices because it balances comfort with discovery. Choosing the right ${place} holiday package helps visitors enjoy hospitality, sightseeing and relaxed downtime without last-minute confusion.`,
    ],
    travellerTypes: [
      {
        title: "For Culture & Art Lovers",
        text: `Art, craft and local traditions are part of everyday life in ${place}. Guided walks, heritage lanes and local workshops help travellers understand the destination beyond regular sightseeing.`,
      },
      {
        title: "For Beach Lovers",
        text: `${place} packages can include calm beaches, sunset points, local cafes and water-side stays where families, couples and groups can spend unhurried time together.`,
      },
      {
        title: "For Backpackers",
        text: `Budget stays, shared transfers and flexible day plans make ${place} easy for backpackers who want to explore more while keeping the trip affordable.`,
      },
      {
        title: "For Foodies",
        text: `Food is a major part of the ${place} experience, from local snacks and traditional meals to cafes and restaurants serving familiar comfort food.`,
      },
      {
        title: "For Couples",
        text: `Private stays, scenic drives, relaxed dinners and curated experiences make ${place} a good choice for honeymoons and short romantic breaks.`,
      },
    ],
    placesTitle: `Top Places Covered In The ${place} Holiday Packages`,
    placesIntro: [
      `Seeing ${place}'s landscapes, local spaces and everyday attractions makes the trip feel more complete. Most itineraries are designed to balance sightseeing, comfort and free time.`,
      `These are the must-visit places that are most often included in ${place} tour packages:`,
    ],
    topPlaces: [
      { name: `${pure} Heritage Point`, text: `A popular stop that helps visitors understand local history, architecture and the character of the destination.` },
      { name: `${pure} Viewpoint`, text: `A scenic location where travellers can enjoy wide views, take photographs and spend a relaxed part of the day.` },
      { name: `${pure} Temple Trail`, text: `A peaceful cultural route that gives travellers a closer look at local rituals, design and community traditions.` },
      { name: `${pure} Market Street`, text: `A busy shopping and food area where visitors can buy souvenirs, try local snacks and see daily life up close.` },
      { name: `${pure} Beachfront`, text: `A relaxed coastal stop with cafes, walks, sunset views and easy time for families, groups and couples.` },
    ],
    shoppingTitle: `Shopping In ${place}`,
    shoppingText: `Markets and small shops in ${place} are part of everyday travel. Handmade items, fabrics, accessories, local snacks and souvenirs are easy to find in popular tourist areas.`,
    shoppingAreas: [`${pure} Art Market`, `${pure} Local Bazaar`, `${pure} Flea Market`, `${pure} Morning Market`, `${pure} Shopping Centre`],
    foodTitle: `Food & Cuisine In ${place}`,
    foodText: `Food in ${place} reflects local habits and regional flavours. Most packages keep meal plans flexible so travellers can try local dishes as well as familiar restaurant options.`,
    foodTable: {
      vegetarian: ["Local veg platter", "Fried rice", "Tofu curry", "Seasonal vegetable stew", "Fresh fruit bowls"],
      nonVegetarian: ["Grilled chicken", "Seafood curry", "Spiced rice meal", "Fish fry", "Local barbecue"],
    },
    bookingTitle: `Book Your ${place} Trip Packages With MakeBeeTrip!`,
    bookingText: `A ${place} trip becomes easier when flights, stays, transfers and sightseeing are planned in advance. Compare itineraries, review inclusions and choose a ${place} holiday package that suits your travel style.`,
  };
}
